import * as types from "./qemu.types";

const initialState = {
	qemu_saved_config: null,
};

export default function qemu_reducer(state = initialState, action) {
	switch (action.type) {
		/* ---------------------------- QEMU SAVE CONFIG ---------------------------- */
		case types.QEMU_SAVE_CONFIG:
			return { ...state, qemu_saved_config: action.payload };

		default:
			return state;
	}
}
